/**
 * Export `fixRegisteredTrademarkSymbol`.
 */

export function fixRegisteredTrademarkSymbol(word: string) {
  return word.replace('®', '<sup>®</sup>');
}
